module.exports = __webpack_public_path__ + "static/media/amela-wiki.42ef3e9b.svg";